import axios from "axios";

export class BgTaskNotifier {
    constructor() {
        this.endpoint = "/autocomplete/bg_tasks"
        this.postFetch = (res) => {};
        this.postFetchErrorHandler = (error) => {};
        this.initialDelay = 2000;
        this.delay = 2000;
        this.pollRunningTasksTimeout = null;
    }

    resetTimer(delay=null) {
        if (delay) {
            this.delay = delay;
        } else {
            this.delay = this.initialDelay;
        }
        if (this.pollRunningTasksTimeout) {
            clearTimeout(this.pollRunningTasksTimeout);
            this.pollRunningTasks();
        }
    }

    fetchRunningTasks() {
        axios.get(this.endpoint).then((res) => {
            // console.log(res);
            this.postFetch(res);
        });
    }

    pollRunningTasks() {
        axios.get(this.endpoint).then((res) => {
            // console.log(res);
            this.postFetch(res);
            this.pollRunningTasksTimeout = setTimeout(this.pollRunningTasks.bind(this), this.delay);
        }).catch(this.postFetchErrorHandler);
        this.delay = Math.min(this.delay * 1.5, 15000); // cap at 10s
    }
}
